import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

const FileAttachment: FC<IconProps> = ({ iconColor = '#2565C8', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="13"
    viewBox="0 0 13 15"
    width="13"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2663 3.93343V3.8001C11.2663 2.67999 11.2663 2.11994 11.0483 1.69212C10.8565 1.31579 10.5506 1.00983 10.1743 0.818085C9.74643 0.600098 9.18638 0.600098 8.06628 0.600098H3.79961C2.6795 0.600098 2.11945 0.600098 1.69163 0.818085C1.3153 1.00983 1.00934 1.31579 0.817596 1.69212C0.599609 2.11994 0.599609 2.67999 0.599609 3.8001V10.7334C0.599609 11.8535 0.599609 12.4136 0.817596 12.8414C1.00934 13.2177 1.3153 13.5237 1.69163 13.7154C2.11945 13.9334 2.6795 13.9334 3.79961 13.9334H6.26628M9.93294 11.2668V7.6001C9.93294 7.04781 10.3807 6.6001 10.9329 6.6001C11.4852 6.6001 11.9329 7.04781 11.9329 7.6001V11.2668C11.9329 12.3713 11.0375 13.2668 9.93294 13.2668C8.82837 13.2668 7.93294 12.3713 7.93294 11.2668V8.6001"
      stroke={iconColor}
    />
  </svg>
);
export default FileAttachment;
